import { formatDate, startOfDay } from 'date-fns';

import { Navigate } from '@sorare/routing';

import { ANY_SPORT_SCOUTING_CENTER_MATCHES_DAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const ScoutingCenterMatchesPage = () => {
  const { generateSportContextPath } = useSportContext();
  const today = startOfDay(new Date());

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SCOUTING_CENTER_MATCHES_DAY, {
        params: {
          day: formatDate(today, 'yyyy-MM-dd'),
        },
      })}
      replace
    />
  );
};

export default ScoutingCenterMatchesPage;
